angular.module('impactx.dashboard').controller('DashboardSystemMessageCtrl', ['$scope', 'dataGen', DashboardSystemMessageCtrl]);

function DashboardSystemMessageCtrl($scope, dataGen) {
    dataGen.getData($scope, {}, "/dashboard/systemmessage").then(function () {
        $scope.isHidden.value = !$scope.data.hasMessage;
    })
}